import container from "../../../libs/container/container";

import sliderListCutFactory from "../../../libs/slider/slider-list-cut";

const amdTopicsDetailsRelatedModule = (function () {
    const name = 'topics-details__related-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {

        const sliderListCutRelated = sliderListCutFactory.create();
        sliderListCutRelated.setCallback('beforeLoadEnd', () => {
            view.methods.calculateCurrentCarouselWidth();
        });
        sliderListCutRelated.init(view.publicVars.sliderListCutRelatedSetup);

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedHeaderMediumCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedCarouselCardHeaderCls, 'animate__fadeInDown50Px', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedCarouselCardGridWrapperOuterCls, 'animate__fadeInRight25P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedButtonContainerCls, 'animate__zoomIn50P', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {
        window.addEventListener('resize', function () {
            view.methods.calculateCurrentCarouselWidth();
        });

        window.addEventListener('orientationchange', function () {
            view.methods.calculateCurrentCarouselWidth();
        });
    };

    view.methods = {
        calculateCurrentCarouselWidth: () => {

            const basicSliderWidth = document.querySelector(view.publicVars.cssId.carouselCardGridWrapperOuterCls).offsetWidth;
            const wrapperPaddingRight = parseInt(window.getComputedStyle(document.querySelector(view.publicVars.cssId.moduleTopicsDetailsRelatedCls)).paddingRight);
            const innerPaddingRight = parseInt(window.getComputedStyle(document.querySelector(view.publicVars.cssId.moduleTopicsDetailsRelatedInner)).paddingRight);
            const carouselCardGap = parseInt(window.getComputedStyle(document.querySelector(view.publicVars.cssId.carouselCardCls)).columnGap);

            let carouselCardWidth = 0;

            if(document.documentElement.clientWidth > 1024) {
                carouselCardWidth = basicSliderWidth + wrapperPaddingRight + innerPaddingRight + carouselCardGap;
            } else {
                carouselCardWidth = basicSliderWidth;
            }

            document.querySelector(view.publicVars.cssId.carouselCardGridWrapperCls).style.width = carouselCardWidth + 'px';

        }
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdTopicsDetailsRelatedModule;